import { TimeEditor } from 'handsontable/editors';

export class TimeInputEditor extends TimeEditor {
  override createElements() {
    super.createElements();
    this.TEXTAREA.className = `custom-time-editor border-box`;
  }
}
